/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MarketStatus from './MarketStatus';
import PilotPilotRarity from './PilotPilotRarity';
import PilotPilotStatType from './PilotPilotStatType';

/**
 * The LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData model module.
 * @module model/LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData
 * @version 1.0
 */
class LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData</code>.
     * @alias module:model/LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData} The populated <code>LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftRarity')) {
                obj['nftRarity'] = PilotPilotRarity.constructFromObject(data['nftRarity']);
            }
            if (data.hasOwnProperty('statType')) {
                obj['statType'] = PilotPilotStatType.constructFromObject(data['statType']);
            }
            if (data.hasOwnProperty('statAmount')) {
                obj['statAmount'] = ApiClient.convertToType(data['statAmount'], 'Number');
            }
            if (data.hasOwnProperty('skillType1')) {
                obj['skillType1'] = ApiClient.convertToType(data['skillType1'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount1')) {
                obj['skillAmount1'] = ApiClient.convertToType(data['skillAmount1'], 'Number');
            }
            if (data.hasOwnProperty('skillType2')) {
                obj['skillType2'] = ApiClient.convertToType(data['skillType2'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount2')) {
                obj['skillAmount2'] = ApiClient.convertToType(data['skillAmount2'], 'Number');
            }
            if (data.hasOwnProperty('skillType3')) {
                obj['skillType3'] = ApiClient.convertToType(data['skillType3'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount3')) {
                obj['skillAmount3'] = ApiClient.convertToType(data['skillAmount3'], 'Number');
            }
            if (data.hasOwnProperty('skillType4')) {
                obj['skillType4'] = ApiClient.convertToType(data['skillType4'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount4')) {
                obj['skillAmount4'] = ApiClient.convertToType(data['skillAmount4'], 'Number');
            }
            if (data.hasOwnProperty('skillType5')) {
                obj['skillType5'] = ApiClient.convertToType(data['skillType5'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount5')) {
                obj['skillAmount5'] = ApiClient.convertToType(data['skillAmount5'], 'Number');
            }
            if (data.hasOwnProperty('property')) {
                obj['property'] = ApiClient.convertToType(data['property'], 'String');
            }
            if (data.hasOwnProperty('metaDataCreatedAt')) {
                obj['metaDataCreatedAt'] = ApiClient.convertToType(data['metaDataCreatedAt'], 'Date');
            }
            if (data.hasOwnProperty('metaDataUpdatedAt')) {
                obj['metaDataUpdatedAt'] = ApiClient.convertToType(data['metaDataUpdatedAt'], 'Date');
            }
            if (data.hasOwnProperty('lastImportedAt')) {
                obj['lastImportedAt'] = ApiClient.convertToType(data['lastImportedAt'], 'Date');
            }
            if (data.hasOwnProperty('slotNumber')) {
                obj['slotNumber'] = ApiClient.convertToType(data['slotNumber'], 'Number');
            }
            if (data.hasOwnProperty('inventoryCreatedAt')) {
                obj['inventoryCreatedAt'] = ApiClient.convertToType(data['inventoryCreatedAt'], 'Date');
            }
            if (data.hasOwnProperty('inventoryUpdatedAt')) {
                obj['inventoryUpdatedAt'] = ApiClient.convertToType(data['inventoryUpdatedAt'], 'Date');
            }
            if (data.hasOwnProperty('listingNo')) {
                obj['listingNo'] = ApiClient.convertToType(data['listingNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('pricePer')) {
                obj['pricePer'] = ApiClient.convertToType(data['pricePer'], 'Number');
            }
            if (data.hasOwnProperty('pricePerString')) {
                obj['pricePerString'] = ApiClient.convertToType(data['pricePerString'], 'String');
            }
            if (data.hasOwnProperty('priceArb')) {
                obj['priceArb'] = ApiClient.convertToType(data['priceArb'], 'Number');
            }
            if (data.hasOwnProperty('priceArbString')) {
                obj['priceArbString'] = ApiClient.convertToType(data['priceArbString'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = MarketStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('registedAt')) {
                obj['registedAt'] = ApiClient.convertToType(data['registedAt'], 'Date');
            }
            if (data.hasOwnProperty('sellerAccountNo')) {
                obj['sellerAccountNo'] = ApiClient.convertToType(data['sellerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('buyerAccountNo')) {
                obj['buyerAccountNo'] = ApiClient.convertToType(data['buyerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('transactedAt')) {
                obj['transactedAt'] = ApiClient.convertToType(data['transactedAt'], 'Date');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['property'] && !(typeof data['property'] === 'string' || data['property'] instanceof String)) {
            throw new Error("Expected the field `property` to be a primitive type in the JSON string but got " + data['property']);
        }
        // ensure the json data is a string
        if (data['pricePerString'] && !(typeof data['pricePerString'] === 'string' || data['pricePerString'] instanceof String)) {
            throw new Error("Expected the field `pricePerString` to be a primitive type in the JSON string but got " + data['pricePerString']);
        }
        // ensure the json data is a string
        if (data['priceArbString'] && !(typeof data['priceArbString'] === 'string' || data['priceArbString'] instanceof String)) {
            throw new Error("Expected the field `priceArbString` to be a primitive type in the JSON string but got " + data['priceArbString']);
        }

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['nftUid'] = undefined;

/**
 * @member {module:model/PilotPilotRarity} nftRarity
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['nftRarity'] = undefined;

/**
 * @member {module:model/PilotPilotStatType} statType
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['statType'] = undefined;

/**
 * @member {Number} statAmount
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['statAmount'] = undefined;

/**
 * @member {Number} skillType1
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillType1'] = undefined;

/**
 * @member {Number} skillAmount1
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillAmount1'] = undefined;

/**
 * @member {Number} skillType2
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillType2'] = undefined;

/**
 * @member {Number} skillAmount2
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillAmount2'] = undefined;

/**
 * @member {Number} skillType3
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillType3'] = undefined;

/**
 * @member {Number} skillAmount3
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillAmount3'] = undefined;

/**
 * @member {Number} skillType4
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillType4'] = undefined;

/**
 * @member {Number} skillAmount4
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillAmount4'] = undefined;

/**
 * @member {Number} skillType5
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillType5'] = undefined;

/**
 * @member {Number} skillAmount5
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['skillAmount5'] = undefined;

/**
 * @member {String} property
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['property'] = undefined;

/**
 * @member {Date} metaDataCreatedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['metaDataCreatedAt'] = undefined;

/**
 * @member {Date} metaDataUpdatedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['metaDataUpdatedAt'] = undefined;

/**
 * @member {Date} lastImportedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['lastImportedAt'] = undefined;

/**
 * @member {Number} slotNumber
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['slotNumber'] = undefined;

/**
 * @member {Date} inventoryCreatedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['inventoryCreatedAt'] = undefined;

/**
 * @member {Date} inventoryUpdatedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['inventoryUpdatedAt'] = undefined;

/**
 * @member {Number} listingNo
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['listingNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} pricePer
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['pricePer'] = undefined;

/**
 * @member {String} pricePerString
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['pricePerString'] = undefined;

/**
 * @member {Number} priceArb
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['priceArb'] = undefined;

/**
 * @member {String} priceArbString
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['priceArbString'] = undefined;

/**
 * @member {module:model/MarketStatus} status
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['status'] = undefined;

/**
 * @member {Date} registedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['registedAt'] = undefined;

/**
 * @member {Number} sellerAccountNo
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['sellerAccountNo'] = undefined;

/**
 * @member {Number} buyerAccountNo
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['buyerAccountNo'] = undefined;

/**
 * @member {Date} transactedAt
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['transactedAt'] = undefined;

/**
 * @member {Number} walletTransactionNo
 */
LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData.prototype['walletTransactionNo'] = undefined;






export default LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData;

